
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as tipsJ1H7GS9KLdkTEisTbIIDuKRPbKpPuaRjNO6L5Q5JQ2gMeta } from "/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/tips.vue?macro=true";
import { default as indexORS0Ie7LFLhkQci_45pkyhRc5H6PK58MelkQWO23rjQcYMeta } from "/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/index.vue?macro=true";
import { default as loginIkH5rL1XPts662nFsPwyoFq9NfiytBO9XfyCHWYU39wMeta } from "/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/login.vue?macro=true";
import { default as Features6A2a9rVGEuNTavTNvgrQR5duS_45pc8iHyv2vit2Er9EIMeta } from "/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/Features.vue?macro=true";
import { default as dashboardeN7WCvH7lxMxtnuwbWU54DCTRUyxIaEgcQ9QQvoi_45GoMeta } from "/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/dashboard.vue?macro=true";
import { default as alln9JZKod2yC5J3p0L5nwn_45RVrj12AuAmuCPISK09qK3wMeta } from "/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/my-waste/all.vue?macro=true";
import { default as index7bFDL0U_45I_mTHeQaNMDbPl_45HROIZsbNqfQzruCTrj54Meta } from "/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/profile/index.vue?macro=true";
import { default as indexNW6VZXutroSG6IKMtLDAnORSmeChTNyEBDBugDJ2qBQMeta } from "/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/my-waste/index.vue?macro=true";
import { default as FeespHjGOJhz2tdZcj1Y7c9Gem8Ikmy9bKjTB5tIGi08pz8Meta } from "/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/_components/Fees.vue?macro=true";
import { default as invoicesnnhytBZwlCWylAHmBdbs_VWN_45RGRhtLf0KOSY_liuOsMeta } from "/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/profile/invoices.vue?macro=true";
import { default as my_45unsorted_45wasteDsalM70t6xQgTe_45DwP0rGr9b_453RpRDzkrF031JokXHYMeta } from "/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/my-unsorted-waste.vue?macro=true";
import { default as FooterTVpJdZwUOn19CJdPOwlLEHynDXMj3FrLki9UTve6REEMeta } from "/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/_components/Footer.vue?macro=true";
import { default as IconInfoBzZnpO0oO_pZFrgYRH1LZd5e0W_45sWrTwvdNzR_45Ap9EsMeta } from "/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/_components/IconInfo.vue?macro=true";
import { default as WasteCardIZK_45bmqUWa7TH7PeuHPB6HllFrEKN8BcnW49hBOTXfwMeta } from "/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/_components/WasteCard.vue?macro=true";
import { default as indexGHOn76MNJNanQtsuRHi1mRyuUeScfhESNKRwwsK26RkMeta } from "/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/collection-yard/index.vue?macro=true";
import { default as notificationsc4MeBctB9rtrY_WNYGbcxTOpZxSjDR7ApapG_EFO_454QMeta } from "/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/profile/notifications.vue?macro=true";
import { default as indexuwJNl58cRWbjkBDEaDJjz_45EWba5bttWKc7EO3n8DTPUMeta } from "/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/collection-point/index.vue?macro=true";
import { default as all_45binsapolQDWqwygH2Kk_UwqNl3FOECJ0q4M5tqtXVUSqUyIMeta } from "/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/collection-point/all-bins.vue?macro=true";
import { default as all_45visitsNWsScP7ehyIr7_QhHD92RtAcTg1ESF6JFV6KUteW97cMeta } from "/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/collection-yard/all-visits.vue?macro=true";
import { default as calculation9Osi3gEFrCl_45Hguv35wpSEaf_1pDrhku5KDKtV_45BVmoMeta } from "/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/collection-point/calculation.vue?macro=true";
export default [
  {
    name: "tips",
    path: "/tips",
    component: () => import("/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/tips.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexORS0Ie7LFLhkQci_45pkyhRc5H6PK58MelkQWO23rjQcYMeta || {},
    component: () => import("/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginIkH5rL1XPts662nFsPwyoFq9NfiytBO9XfyCHWYU39wMeta || {},
    component: () => import("/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/login.vue")
  },
  {
    name: "Features",
    path: "/Features",
    component: () => import("/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/Features.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/dashboard.vue")
  },
  {
    name: "my-waste-all",
    path: "/my-waste/all",
    component: () => import("/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/my-waste/all.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/profile/index.vue")
  },
  {
    name: "my-waste",
    path: "/my-waste",
    component: () => import("/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/my-waste/index.vue")
  },
  {
    name: "_components-Fees",
    path: "/_components/Fees",
    component: () => import("/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/_components/Fees.vue")
  },
  {
    name: "profile-invoices",
    path: "/profile/invoices",
    component: () => import("/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/profile/invoices.vue")
  },
  {
    name: "my-unsorted-waste",
    path: "/my-unsorted-waste",
    component: () => import("/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/my-unsorted-waste.vue")
  },
  {
    name: "_components-Footer",
    path: "/_components/Footer",
    component: () => import("/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/_components/Footer.vue")
  },
  {
    name: "_components-IconInfo",
    path: "/_components/IconInfo",
    component: () => import("/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/_components/IconInfo.vue")
  },
  {
    name: "_components-WasteCard",
    path: "/_components/WasteCard",
    component: () => import("/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/_components/WasteCard.vue")
  },
  {
    name: "collection-yard",
    path: "/collection-yard",
    component: () => import("/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/collection-yard/index.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    component: () => import("/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/profile/notifications.vue")
  },
  {
    name: "collection-point",
    path: "/collection-point",
    component: () => import("/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/collection-point/index.vue")
  },
  {
    name: "collection-point-all-bins",
    path: "/collection-point/all-bins",
    component: () => import("/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/collection-point/all-bins.vue")
  },
  {
    name: "collection-yard-all-visits",
    path: "/collection-yard/all-visits",
    component: () => import("/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/collection-yard/all-visits.vue")
  },
  {
    name: "collection-point-calculation",
    path: "/collection-point/calculation",
    component: () => import("/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/pages/collection-point/calculation.vue")
  }
]